/**
 * Constants for ad types supported
 *
 * @namespace constants.adTypes
 */
export default {
  freewheel: 'freewheel',
  manifestManipulator: 'manifestManipulator'
};
